import { render, staticRenderFns } from "./DialogGift.vue?vue&type=template&id=513ff9c0"
import script from "./DialogGift.vue?vue&type=script&lang=js"
export * from "./DialogGift.vue?vue&type=script&lang=js"
import style0 from "./DialogGift.vue?vue&type=style&index=0&id=513ff9c0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports